export const vatCodeFrag = `
    id
    name
    code
    amount
    included
`;
